__turbopack_context__.v({
  "divider": "Divider-module__iTs9tq__divider",
});
